// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".te-page{background-color:var(--page-bg-color);width:100%;margin:2px 2px;border-top-left-radius:4px;border-top-right-radius:4px;overflow:auto;padding:10px 10px;height:100%}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
